import images from '@assets/images/index'
import { cx } from 'class-variance-authority'
import React from 'react'

import { Button } from '../Button/Button'

type BubbleModalProps = {
  className?: string
  children: React.ReactNode
  isOpen: boolean
  handleClose: () => void
}

/**
 * returns JSX for bubble modal
 */
export function BubbleModal({
  className = '',
  children,
  isOpen,
  handleClose
}: Readonly<BubbleModalProps>) {
  return (
    <div className={cx('bubble-modal', className, { active: isOpen })}>
      <div className="bubble-modal__menu">
        <div className="bubble-modal__bg-disc" />
        <Button
          className="bubble-modal__close"
          aria-label="Close"
          intent="icon"
          onClick={handleClose}
        >
          <images.LoginClose />
        </Button>
        <div className="bubble-modal__content">{isOpen ? children : null}</div>
      </div>
      <div className="bubble-modal__dim" />
    </div>
  )
}
